module.exports = __webpack_public_path__ + "static/media/card-header-bg.7fd81535.jpg";